import { TypeKeys } from "../actions";
import { swApi } from "../global/app";
import { RouterEventDetail } from "@ionic/core";
import { trackIntercomEvent } from "../global/intercom";
import { cancelWorkout } from "./workout-player";
import { stopVoiceCommands, initVoiceCommands } from "./voice-commands";
// import { amplitudeLogEvent, AmplitudeEvents } from '../global/amplitude';
import { statusBarManager } from "../global/status-bar";
import { Capacitor } from "@capacitor/core";

export const routeChanged =
  (routeDetail: RouterEventDetail) => async (dispatch, _getState) => {
    dispatch(setRouteDetail(routeDetail));
    const toPage = routeDetail.to;
    const fromPage = routeDetail.from;
    trackIntercomEvent("page_view", { page: toPage });
    // amplitudeLogEvent(AmplitudeEvents.page_view, { page: toPage });
    if (swApi && swApi.analytics) {
      swApi.analytics.screenview(toPage);
    }
    resetFirebaseUI(fromPage);
    if (Capacitor.isNativePlatform()) {
      // console.log("routeChanged toPage", toPage);
      statusBarManager.updateStatusBar(toPage);
    }
    if (shouldCancelWorkout(fromPage, toPage)) {
      dispatch(cancelWorkout());
    }
    if (!toPage.includes("player")) {
      dispatch(stopVoiceCommands());
    } else {
      dispatch(initVoiceCommands());
    }
  };

export interface SetRouteDetail {
  type: TypeKeys.SET_ROUTE_DETAIL;
  routeDetail: RouterEventDetail;
}

function setRouteDetail(routeDetail: RouterEventDetail) {
  const action: SetRouteDetail = {
    type: TypeKeys.SET_ROUTE_DETAIL,
    routeDetail,
  };
  return action;
}

function resetFirebaseUI(fromPage: string) {
  if (!fromPage) return;
  const fromLoginPage = fromPage.includes("/login");
  if (fromLoginPage) {
    //reset firebaseui - only needed for navigation from login <-> subscribe
    console.debug("resetting firebaseui");
    const firebaseui = document.querySelectorAll("sw-firebase-ui-wrapper");
    if (firebaseui && firebaseui.length) {
      for (let i = 0; i < firebaseui.length; i++) {
        firebaseui[i].reset();
      }
    }
  }
}

function shouldCancelWorkout(fromPage: string, toPage: string) {
  if (toPage && fromPage) {
    const toEndWorkout = toPage.includes("end-workout");
    const toWorkoutPlayer = toPage.includes("player");
    const fromWorkoutPlayer = fromPage.includes("player");
    if (toWorkoutPlayer || toEndWorkout) {
      console.debug("sw-app starting/ending workout: NOT cancelling workout");
      return false;
    } else if (fromWorkoutPlayer) {
      console.debug("cancelling workout, leaving workout player");
      return true;
    } else {
      console.debug("NOT cancelling workout");
      return false;
    }
  } else {
    return false;
  }
}

export function isPageWithDarkBackgroundLightIcons(URL: string) {
  // Check if we're on the end workout page component
  //@todo ensure white status bar icons on end workout page
  if (document.querySelector('sw-end-workout-page')) {
    return true;
  }
  
  if (URL.indexOf("/time-select") !== -1) {
    return false;
  } else if (URL.indexOf("/music-select") !== -1) {
    return false;
  } else if (URL.indexOf("/player") !== -1) {
    return false;
  } else if (URL.indexOf("/end-workout") !== -1) {
    return true;
  } else if (URL.indexOf("/goals/") !== -1) {
    return true;
  } else {
    const lightIconsUrlPrefixes = [
      "/welcome",
      "/challenges",
      "/collections",
      "/custom",
      "/help",
      "/favorites",
      "/plans",
      "/my-sworkit",
      "/my-sworkit/distance",
      "/my-sworkit/steps",
      "/my-sworkit/stats",
      "/my-sworkit/workout-log",
      "/my-sworkit/workouts-summary",
      "/onboarding",
      "/view-challenge-banners",
      "/view-promos",
    ];
    // Check if URL starts with any of the light prefixes
    return lightIconsUrlPrefixes.some((prefix) => URL.startsWith(prefix));
  }
}

export function isPageWithLightBackground(URL: string) {
  const darkIconsUrlPrefixes = ["/login"];
  return darkIconsUrlPrefixes.some((prefix) => URL.startsWith(prefix));
}
